export default (function (array) {
  return array[array.length - 1];
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/getLastElement.js
// module id = vfE8
// module chunks = 0